var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcuario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M816.75,277.4l177.09,177.09-50.59,50.59-126.5-127.64-154.09,150.64-151.81-150.64-152.94,150.64-151.81-150.64-129.94,127.64-49.45-51.75,179.39-175.94,151.81,150.64,154.09-150.64,150.66,150.64,154.09-150.64ZM816.75,566.04l177.09,177.11-50.59,50.59-126.5-126.5-154.09,150.66-151.81-150.66-152.94,150.66-151.81-150.66-129.94,126.5-49.45-50.59,179.39-177.11,151.81,150.66,154.09-150.66,150.66,150.66,154.09-150.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcuario);
export default __webpack_public_path__ + "static/media/Acuario.642eb62b95b5f63aaa17ca7eb992b76f.svg";
export { ForwardRef as ReactComponent };